const baseUrl = 'https://kb.aampe.com/';

export { baseUrl };
export const apiDocsUrl = baseUrl + 'api-guide/';

// Provider documentation paths
export const messageProvidersPath =
    baseUrl + 'developer-guide/message-providers/message-pages/';
export const dataSourcesPath =
    baseUrl + 'developer-guide/data-ingest/data-sources/';

// Maps backend docs_name values to their correct kb.aampe.com URL slugs when
// the slug differs from the docs_name (e.g. amplitude ships as "amplitude"
// but the correct page path is "amplitude-batch#option-3-amplitude-export-api").
export const DATA_SOURCE_SLUG_OVERRIDES: Record<string, string> = {
    amplitude: 'amplitude-batch#option-3-amplitude-export-api',
};

export const AGENTIC_LEARNING_DOC_URL =
    baseUrl + 'developer-guide/data-ingest/data-management#agentic-learning';
export const LABELING_YOUR_CONTENT =
    baseUrl + 'user-guide/welcome-to-aampe/how-does-aampe-work/labels';
